import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the searched companies list key, so a debounced keystroke re-keys THIS match and not the
// page above it — which paints its skeleton at `pendingMs: 0` and would unmount the search box mid-word. The search
// box writes `q`/`p` to the URL, so the loader and the list read the ONE object built here. No component: nothing
// to code-split, nothing painted on a re-key. The page reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/account/api/$appId/companies/_list')({
  loaderDeps: ({ search }) => ({ p: search.p, q: search.q }),
  context: ({ deps, params }) => ({
    appCompaniesQueryOptions: trpc.apps.getCompanies.queryOptions({
      appClientId: params.appId,
      search: { q: deps.q || undefined, p: deps.p },
    }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.appCompaniesQueryOptions).catch(noop)
  },
})
